// extracted by mini-css-extract-plugin
export default {"productImgSet":"ProductImgSet_productImgSet__oG5Gk"};